// TooltipPortal.tsx
import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom";

interface TooltipPortalProps {
  targetRef: React.RefObject<HTMLElement>;
  children: React.ReactNode;
}

const TooltipPortal: React.FC<TooltipPortalProps> = ({ targetRef, children }) => {
  const [position, setPosition] = useState({ top: 0, left: 0 });

  useEffect(() => {
    if (targetRef.current) {
      const rect = targetRef.current.getBoundingClientRect();
      setPosition({
        top: rect.top + window.scrollY,
        left: rect.left + window.scrollX,
      });
    }
  }, [targetRef]);

  return ReactDOM.createPortal(
    <div style={{ position: "absolute", top: position.top, left: position.left + 13 }}>
      {children}
    </div>,
    document.body
  );
};

export default TooltipPortal;
